"use strict";

let runtimeComponentsModule = require('@runtime/components');

module.exports.defineDesignerComponents = function defineDesignerComponents(pyModule) {

    require('./components/DesignLabel.js')(pyModule);

    require('./components/DesignRichText.js')(pyModule);

    require('./components/DesignSpacer.js')(pyModule);

    require('./components/DesignTextBox.js')(pyModule);

    require('./components/DesignTextArea.js')(pyModule);

    require('./components/DesignLinearPanel.js')(pyModule);

    require('./components/DesignRepeatingPanel.js')(pyModule, runtimeComponentsModule);

    require("./components/DesignDataGrid")(pyModule);

    require("./components/DesignDataRowPanel")(pyModule);

    require('./components/DesignXYPanel.js')(pyModule);

    require('./components/DesignGridPanel.js')(pyModule);

    require('./components/DesignColumnPanel.js')(pyModule);

    require('./components/DesignHtmlPanel.js')(pyModule);

    require('./components/DesignHtmlTemplate.js')(pyModule);

    require('./components/DesignFlowPanel.js')(pyModule);

    require('./components/DesignImage.js')(pyModule);

    require('./components/DesignYouTubeVideo.js')(pyModule);

    require('./components/DesignLink.js')(pyModule);

    if (window['google']) {
        require('./components/DesignGoogleMap.js')(pyModule);
    } else {
        console.warn("Google unavailable, not loading DesignGoogleMap component.");
    }

    require("./components/DesignPlot")(pyModule);
};